var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QRenewedControl',_vm._g(_vm._b({staticClass:"renewed-text-area",scopedSlots:_vm._u([{key:"default",fn:function({ on, attrs }){return [_c('v-textarea',_vm._g(_vm._b({class:{ 'renewed-text-area--resize-none': !_vm.resize }},'v-textarea',attrs,false),on))]}}])},'QRenewedControl',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }